var chunkMapping = {
	"1742": [
		91742
	],
	"2380": [
		52380
	],
	"2603": [
		32603
	],
	"2803": [
		12803
	],
	"4567": [
		84567
	],
	"7316": [
		7316
	],
	"7920": [
		7920
	],
	"9065": [
		69065
	]
};
var idToExternalAndNameMapping = {
	"7316": [
		"default",
		"./MarketPage",
		35114
	],
	"7920": [
		"default",
		"./FoodPage",
		35114
	],
	"12803": [
		"default",
		"./MessengerPage",
		35114
	],
	"32603": [
		"default",
		"./JournalPage",
		35114
	],
	"52380": [
		"default",
		"./TutoringPage",
		35114
	],
	"69065": [
		"default",
		"./StatisticsPage",
		35114
	],
	"84567": [
		"default",
		"./TutorsPage",
		35114
	],
	"91742": [
		"default",
		"./AnnouncementsPage",
		35114
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}